// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recording-dialog__container .recording-dialog__toggle {
    position: relative;
    bottom: -7px;
    right: 3px;
    color: rgba(0, 0, 0, 0.87);
    opacity: 0.7;
    transition: opacity 0.2s ease-in-out;
    font-size: 2rem;
    cursor: pointer;
}

.recording-dialog__toggle:hover, .recording-dialog__toggle:focus {
    opacity: 1;
}

.recording-dialog__modal {
    margin-top: 23vh;
    max-width: 400px;
    width: 400px;
}

.recording-dialog__modal .modal-body {
    padding: 0;
}

.recording-dialog__modal .modal-title {
    width: 100%;
}

.recording-modal__header {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.recording-modal__header-close-btn-container {
    display: flex;
    flex-direction: row-reverse;
}

.recording-modal__header-tab-container {
    display: flex;
    font-size: 2.5rem;
}

.recording-dialog__modal .modal-content {
    padding-top: 5px;
    padding-bottom: 10px;
}

.recording-dialog__modal .modal-header {
    padding: 0 5px;
}

.recording-modal__tab {
    flex: 1;
    text-align: center;
    cursor: pointer;
    font-weight: bold;
    padding: 5px 0px 7px 0px;
    border-radius: 4px;
    transition: background 0.2s ease-in-out;
    user-select: none;
}

.recording-modal__tab.active {
    background: #26a6995d;
}

.recording-modal__tab.disabled {
    cursor: not-allowed;
}

.recording-control {
    border-radius: 4px;
    font-size: 1.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    box-sizing: border-box;
    width: 12rem;
    position: relative;
}

.record-icon, .stop-icon {
    margin-left: -10px;
}

.recording-controls__container {
    display: flex;
    align-items: center;
    gap: 10px;
}

.stop-recording__btn:not(:disabled) {
    background-color: #d22e37;
}

.recording__stopwatch {
    font-weight: bold;
    font-size: 2.2rem;
}

.recording-modal-footer__container {
    display: flex;
    width: 100%;
    justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/recording-dialog/RecordingDialog.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,0BAA0B;IAC1B,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,kBAAkB;IAClB,uCAAuC;IACvC,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,8BAA8B;AAClC","sourcesContent":[".recording-dialog__container .recording-dialog__toggle {\r\n    position: relative;\r\n    bottom: -7px;\r\n    right: 3px;\r\n    color: rgba(0, 0, 0, 0.87);\r\n    opacity: 0.7;\r\n    transition: opacity 0.2s ease-in-out;\r\n    font-size: 2rem;\r\n    cursor: pointer;\r\n}\r\n\r\n.recording-dialog__toggle:hover, .recording-dialog__toggle:focus {\r\n    opacity: 1;\r\n}\r\n\r\n.recording-dialog__modal {\r\n    margin-top: 23vh;\r\n    max-width: 400px;\r\n    width: 400px;\r\n}\r\n\r\n.recording-dialog__modal .modal-body {\r\n    padding: 0;\r\n}\r\n\r\n.recording-dialog__modal .modal-title {\r\n    width: 100%;\r\n}\r\n\r\n.recording-modal__header {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n}\r\n\r\n.recording-modal__header-close-btn-container {\r\n    display: flex;\r\n    flex-direction: row-reverse;\r\n}\r\n\r\n.recording-modal__header-tab-container {\r\n    display: flex;\r\n    font-size: 2.5rem;\r\n}\r\n\r\n.recording-dialog__modal .modal-content {\r\n    padding-top: 5px;\r\n    padding-bottom: 10px;\r\n}\r\n\r\n.recording-dialog__modal .modal-header {\r\n    padding: 0 5px;\r\n}\r\n\r\n.recording-modal__tab {\r\n    flex: 1;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    font-weight: bold;\r\n    padding: 5px 0px 7px 0px;\r\n    border-radius: 4px;\r\n    transition: background 0.2s ease-in-out;\r\n    user-select: none;\r\n}\r\n\r\n.recording-modal__tab.active {\r\n    background: #26a6995d;\r\n}\r\n\r\n.recording-modal__tab.disabled {\r\n    cursor: not-allowed;\r\n}\r\n\r\n.recording-control {\r\n    border-radius: 4px;\r\n    font-size: 1.2rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 0.5rem;\r\n    box-sizing: border-box;\r\n    width: 12rem;\r\n    position: relative;\r\n}\r\n\r\n.record-icon, .stop-icon {\r\n    margin-left: -10px;\r\n}\r\n\r\n.recording-controls__container {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\n.stop-recording__btn:not(:disabled) {\r\n    background-color: #d22e37;\r\n}\r\n\r\n.recording__stopwatch {\r\n    font-weight: bold;\r\n    font-size: 2.2rem;\r\n}\r\n\r\n.recording-modal-footer__container {\r\n    display: flex;\r\n    width: 100%;\r\n    justify-content: space-between;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
